var _circle, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutcome2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F43E3E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1049_108177",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1049_108177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 26V27C14 27.2833 13.9042 27.5208 13.7125 27.7125C13.5208 27.9042 13.2833 28 13 28H12C11.7167 28 11.4792 27.9042 11.2875 27.7125C11.0958 27.5208 11 27.2833 11 27V19L13.1 13C13.2 12.7 13.3792 12.4583 13.6375 12.275C13.8958 12.0917 14.1833 12 14.5 12H25.5C25.8167 12 26.1042 12.0917 26.3625 12.275C26.6208 12.4583 26.8 12.7 26.9 13L29 19V27C29 27.2833 28.9042 27.5208 28.7125 27.7125C28.5208 27.9042 28.2833 28 28 28H27C26.7167 28 26.4792 27.9042 26.2875 27.7125C26.0958 27.5208 26 27.2833 26 27V26H14ZM13.8 17H26.2L25.15 14H14.85L13.8 17ZM15.5 23C15.9167 23 16.2708 22.8542 16.5625 22.5625C16.8542 22.2708 17 21.9167 17 21.5C17 21.0833 16.8542 20.7292 16.5625 20.4375C16.2708 20.1458 15.9167 20 15.5 20C15.0833 20 14.7292 20.1458 14.4375 20.4375C14.1458 20.7292 14 21.0833 14 21.5C14 21.9167 14.1458 22.2708 14.4375 22.5625C14.7292 22.8542 15.0833 23 15.5 23ZM24.5 23C24.9167 23 25.2708 22.8542 25.5625 22.5625C25.8542 22.2708 26 21.9167 26 21.5C26 21.0833 25.8542 20.7292 25.5625 20.4375C25.2708 20.1458 24.9167 20 24.5 20C24.0833 20 23.7292 20.1458 23.4375 20.4375C23.1458 20.7292 23 21.0833 23 21.5C23 21.9167 23.1458 22.2708 23.4375 22.5625C23.7292 22.8542 24.0833 23 24.5 23Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutcome2);
export default __webpack_public_path__ + "static/media/outcome2.d1ff41147dcd23a7906b2e77c67db4d9.svg";
export { ForwardRef as ReactComponent };